export const Routes = ["/", "/step-two", "/step-three", "/step-four"];


// WEBPACK FOOTER //
// ./app/classes/routes.ts